import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { AppView } from '../app'

const root = createRoot(document.getElementById('react-app')!)
root.render(<AppView />)
